import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import store from '../';
import globals from '../../utils/globals';
import { CurrencyConversionServiceReadyEvent, LocalizedContentServiceReadyEvent } from '@studyportals/portal-localized-content';
import { IStore } from '../../interfaces';
import { CopilotServiceReadyEvent } from '@studyportals/copilot-service-interfaces';
import { PortalType } from '@studyportals/domain-client';

export class DependencyCheckerPlugin implements ISubscriber<LocalizedContentServiceReadyEvent | CurrencyConversionServiceReadyEvent | CopilotServiceReadyEvent> {
	private localizedContentServiceIsReady = false;
	private currencyConversionServiceIsReady = false;
	private copilotServiceIsReady = false;
	private store: IStore;

	constructor() {
		this.store = store;
	}

	public initiate(): void {
		const eventAggregationService = window.EventAggregationService;
		if (!eventAggregationService) {
			return;
		}

		eventAggregationService.subscribeTo(LocalizedContentServiceReadyEvent.EventType, this, true);
		eventAggregationService.subscribeTo(CurrencyConversionServiceReadyEvent.EventType, this, true);

		if (window.PortalType !== PortalType.MASTER) return;

		eventAggregationService.subscribeTo(CopilotServiceReadyEvent.EventType, this, true);
	}

	public async notify(event: LocalizedContentServiceReadyEvent | CurrencyConversionServiceReadyEvent | CopilotServiceReadyEvent): Promise<void> {
		if (event.eventType === LocalizedContentServiceReadyEvent.EventType) {
			this.handleLocalizedContentServiceReadyEvent(event as LocalizedContentServiceReadyEvent);
		}

		if (event.eventType === CurrencyConversionServiceReadyEvent.EventType) {
			this.handleCurrencyConversionServiceReadyEvent(event as CurrencyConversionServiceReadyEvent);
		}

		if (event.eventType === CopilotServiceReadyEvent.EventType) {
			this.handleCopilotServiceReadyEvent(event as CopilotServiceReadyEvent);
		}

		if (this.currencyConversionServiceIsReady &&
			this.localizedContentServiceIsReady &&
			(this.copilotServiceIsReady || window.PortalType !== PortalType.MASTER)
		) {
			await this.store.actions.setAreDependenciesLoaded(true);
		}
	}

	private handleCopilotServiceReadyEvent(event: CopilotServiceReadyEvent): void {
		globals.copilotService = event.copilotServiceApplication;
		this.copilotServiceIsReady = true;
	}

	private handleLocalizedContentServiceReadyEvent(event: LocalizedContentServiceReadyEvent): void {
		globals.localizedContentService = event.localizedContentService;
		this.localizedContentServiceIsReady = true;
	}

	private handleCurrencyConversionServiceReadyEvent(event: CurrencyConversionServiceReadyEvent): void {
		globals.currencyConversionService = event.currencyConversionService;
		this.currencyConversionServiceIsReady = true;
	}
}
